import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="py-8 text-white bg-[#2E3333]">
      <div className="max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
          {/* Legal Section */}
          <div className='bg-[#434848] p-4'>
            <h2 className="mb-4 text-lg font-bold">Legal</h2>
            <ul className="space-y-2">
              <li><a href="#" className="hover:underline">Terms and conditions</a></li>
              <li><a href="#" className="hover:underline">Privacy</a></li>
              <li><a href="#" className="hover:underline">Cookies</a></li>
              <li><a href="#" className="hover:underline">Public Authority Requests</a></li>
            </ul>
          </div>

          {/* Help Section */}
          <div className='bg-[#434848] p-4'>
            <h2 className="mb-4 text-lg font-bold">Help</h2>
            <ul className="space-y-2">
              <li><a href="#" className="hover:underline">Contact</a></li>
              <li><a href="#" className="hover:underline">FAQs</a></li>
              <li><a href="#" className="hover:underline">Cuisines</a></li>
            </ul>
          </div>

          {/* Download Section */}
          <div className='bg-[#434848] p-4'>
            <h2 className="mb-4 text-lg font-bold">Take Deliveroo with you</h2>
            <div className="flex space-x-4">
<img src="https://consumer-component-library.roocdn.com/30.44.9/static/images/app-store-badges-en.svg" alt="" />
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="flex flex-col items-center justify-between mt-8 sm:flex-row">
          <div className="flex space-x-4 text-2xl">
            <a href="#" aria-label="Facebook"><FaFacebook /></a>
            <a href="#" aria-label="Twitter"><FaTwitter /></a>
            <a href="#" aria-label="Instagram"><FaInstagram /></a>
          </div>
          <p className="mt-4 text-sm sm:mt-0">&copy; 2024 Deliveroo</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
